import PropTypes from 'prop-types';
import React, { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/SearchField/SearchField.container';
import { DeviceType } from 'Type/Device.type';
import { scrollToTop } from 'Util/Browser';
import { noopFn } from 'Util/Common';
import { history } from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

import SearchField from './SearchField.component';

/** @namespace PeggysagePwa/Component/SearchField/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace PeggysagePwa/Component/SearchField/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/SearchField/Container */
export class SearchFieldContainer extends PureComponent {
    static propTypes = {
        searchCriteria: PropTypes.string,
        onSearchBarFocus: PropTypes.func.isRequired,
        onSearchBarChange: PropTypes.func.isRequired,
        onSearchOutsideClick: PropTypes.func.isRequired,
        onClearSearchButtonClick: PropTypes.func.isRequired,
        isVisible: PropTypes.bool,
        isActive: PropTypes.bool,
        hideActiveOverlay: PropTypes.func,
        isHideOverlay: PropTypes.bool,
        isClickOutsideDisabled: PropTypes.bool,
        isFocused: PropTypes.bool,
        device: DeviceType.isRequired
    };

    static defaultProps = {
        searchCriteria: '',
        isVisible: true,
        isActive: true,
        hideActiveOverlay: noopFn,
        isHideOverlay: false,
        isClickOutsideDisabled: false,
        isFocused: false
    };

    searchBarRef = createRef();

    containerFunctions = {
        onClearSearchButtonClick: this.onClearSearchButtonClick.bind(this),
        onSearchEnterPress: this.onSearchEnterPress.bind(this),
        onIconClick: this.onIconClick.bind(this),
        openSearch: this.openSearch.bind(this),
        closeSearch: this.closeSearch.bind(this),
        handleChange: this.handleChange.bind(this),
        clearSearch: this.clearSearch.bind(this)
    };

    componentDidMount() {
        const { isFocused } = this.props;

        if (isFocused && this.searchBarRef.current) {
            this.searchBarRef.current.focus();
        }
    }

    onClearSearchButtonClick(isFocusOnSearchBar = true) {
        const { onClearSearchButtonClick } = this.props;

        if (isFocusOnSearchBar) {
            this.searchBarRef.current.focus();
        }
        onClearSearchButtonClick();
    }

    onSearchEnterPress(e) {
        const { searchCriteria, hideActiveOverlay, onSearchBarChange } = this.props;
        const search = encodeURIComponent(searchCriteria.trim().replace(/%/g, '%25'));
        const trimmedSearch = searchCriteria.trim();

        if (e.key === 'Enter' && trimmedSearch !== '') {
            history.push(appendWithStoreCode(`/search/${ search }`));
            hideActiveOverlay();
            onSearchBarChange({ target: { value: '' } });
            this.searchBarRef.current.blur();
            this.closeSearch();
            scrollToTop();
        }
    }

    onIconClick() {
        this.searchBarRef.current.focus();
    }

    openSearch() {
        const { onSearchBarFocus } = this.props;

        onSearchBarFocus();
    }

    closeSearch() {
        const { onSearchOutsideClick } = this.props;

        onSearchOutsideClick();
    }

    handleChange(e) {
        const { onSearchBarChange } = this.props;

        onSearchBarChange(e);
    }

    clearSearch() {
        this.onClearSearchButtonClick(false);
    }

    containerProps() {
        const {
            searchCriteria,
            onSearchBarFocus,
            onSearchBarChange,
            onSearchOutsideClick,
            isVisible,
            isActive,
            hideActiveOverlay,
            isHideOverlay,
            isClickOutsideDisabled,
            isFocused,
            device
        } = this.props;

        return {
            searchCriteria,
            onSearchBarFocus,
            onSearchBarChange,
            onSearchOutsideClick,
            isVisible,
            isActive,
            hideActiveOverlay,
            isHideOverlay,
            isClickOutsideDisabled,
            isFocused,
            device,
            searchBarRef: this.searchBarRef
        };
    }

    render() {
        return (
            <SearchField
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFieldContainer);
